const decodeImage = async (url) => {
  const img = new Image();
  img.src = url;
  await img.decode();
  return img;
};

export default decodeImage;
